/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Tabmemberslist3Inputs */

const zh_organizationsettings_tabmemberslist3 = /** @type {(inputs: Organizationsettings_Tabmemberslist3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`团队成员`)
};

const en_organizationsettings_tabmemberslist3 = /** @type {(inputs: Organizationsettings_Tabmemberslist3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Members`)
};

const es_organizationsettings_tabmemberslist3 = /** @type {(inputs: Organizationsettings_Tabmemberslist3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miembros del equipo`)
};

/**
* | output |
* | --- |
* | "Team Members" |
*
* @param {Organizationsettings_Tabmemberslist3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_tabmemberslist3 = /** @type {((inputs?: Organizationsettings_Tabmemberslist3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Tabmemberslist3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_tabmemberslist3(inputs)
	if (locale === "en") return en_organizationsettings_tabmemberslist3(inputs)
	return es_organizationsettings_tabmemberslist3(inputs)
});
export { organizationsettings_tabmemberslist3 as "organizationSettings_tabMembersList" }